module.exports = __webpack_public_path__ + "static/media/bg2.0e42e1cf.png";